import { render, staticRenderFns } from "./uploadWorks.vue?vue&type=template&id=65e39793&scoped=true"
import script from "./uploadWorks.vue?vue&type=script&lang=js"
export * from "./uploadWorks.vue?vue&type=script&lang=js"
import style0 from "./uploadWorks.vue?vue&type=style&index=0&id=65e39793&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e39793",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e39793')) {
      api.createRecord('65e39793', component.options)
    } else {
      api.reload('65e39793', component.options)
    }
    module.hot.accept("./uploadWorks.vue?vue&type=template&id=65e39793&scoped=true", function () {
      api.rerender('65e39793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadWorks/uploadWorks.vue"
export default component.exports